import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: { padding: 30, fontFamily: 'Helvetica', fontSize: 10 },
  header: { backgroundColor: '#2E7D32', color: '#ffffff', padding: 15, marginBottom: 20 },
  headerTitle: { fontSize: 18, fontWeight: 'bold' },
  headerSubtitle: { fontSize: 10, opacity: 0.9, marginTop: 4 },
  statsRow: { flexDirection: 'row', marginBottom: 20, gap: 10 },
  statBox: { flex: 1, border: '1px solid #e0e0e0', padding: 12, backgroundColor: '#f5f5f5', textAlign: 'center' },
  statValue: { fontSize: 18, fontWeight: 'bold', marginBottom: 2 },
  statLabel: { fontSize: 8, color: '#666666' },
  table: { marginBottom: 20 },
  tableHeader: { flexDirection: 'row', backgroundColor: '#e8f5e9', borderBottom: '2px solid #2E7D32' },
  tableRow: { flexDirection: 'row', borderBottom: '1px solid #e0e0e0' },
  tableRowAlt: { flexDirection: 'row', borderBottom: '1px solid #e0e0e0', backgroundColor: '#fafafa' },
  cell: { padding: 8 },
  cellDestino: { width: 50 },
  cellNombre: { width: 120 },
  cellNum: { width: 50, textAlign: 'center' },
  cellPeso: { width: 80, textAlign: 'right' },
  cellPorc: { width: 50, textAlign: 'right' },
  headerCell: { fontWeight: 'bold', fontSize: 9 },
  footer: { position: 'absolute', bottom: 30, left: 30, right: 30, borderTop: '1px solid #e0e0e0', paddingTop: 10, flexDirection: 'row', justifyContent: 'space-between', fontSize: 8, color: '#666666' },
});

const ReporteDestinosPDF = ({ data, filters }) => {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.header}>
          <Text style={styles.headerTitle}>Carga por Destino</Text>
          <Text style={styles.headerSubtitle}>
            Período: {filters.fecha_inicio} al {filters.fecha_fin}
          </Text>
        </View>

        <View style={styles.statsRow}>
          <View style={styles.statBox}>
            <Text style={styles.statValue}>{data.resumen.total_destinos}</Text>
            <Text style={styles.statLabel}>DESTINOS ATENDIDOS</Text>
          </View>
          <View style={styles.statBox}>
            <Text style={styles.statValue}>{(data.resumen.peso_total_kg / 1000).toFixed(1)}t</Text>
            <Text style={styles.statLabel}>PESO TOTAL (KG)</Text>
          </View>
          <View style={styles.statBox}>
            <Text style={styles.statValue}>{Math.round(data.resumen.peso_total_lbs).toLocaleString()}</Text>
            <Text style={styles.statLabel}>PESO TOTAL (LBS)</Text>
          </View>
        </View>

        <View style={styles.table}>
          <View style={styles.tableHeader}>
            <Text style={[styles.cell, styles.cellDestino, styles.headerCell]}>DEST</Text>
            <Text style={[styles.cell, styles.cellNombre, styles.headerCell]}>NOMBRE</Text>
            <Text style={[styles.cell, styles.cellNum, styles.headerCell]}>VUELOS</Text>
            <Text style={[styles.cell, styles.cellNum, styles.headerCell]}>PALLETS</Text>
            <Text style={[styles.cell, styles.cellPeso, styles.headerCell]}>PESO (kg)</Text>
            <Text style={[styles.cell, styles.cellPeso, styles.headerCell]}>PESO (lbs)</Text>
            <Text style={[styles.cell, styles.cellPorc, styles.headerCell]}>%</Text>
          </View>
          {data.destinos.map((d, idx) => (
            <View key={d.destino} style={idx % 2 === 0 ? styles.tableRow : styles.tableRowAlt}>
              <Text style={[styles.cell, styles.cellDestino, { fontWeight: 'bold' }]}>{d.destino}</Text>
              <Text style={[styles.cell, styles.cellNombre]}>{d.nombre_destino}</Text>
              <Text style={[styles.cell, styles.cellNum]}>{d.total_vuelos}</Text>
              <Text style={[styles.cell, styles.cellNum]}>{d.total_pallets}</Text>
              <Text style={[styles.cell, styles.cellPeso]}>{d.peso_total_kg.toLocaleString()}</Text>
              <Text style={[styles.cell, styles.cellPeso]}>{Math.round(d.peso_total_lbs).toLocaleString()}</Text>
              <Text style={[styles.cell, styles.cellPorc]}>{d.porcentaje}%</Text>
            </View>
          ))}
        </View>

        <View style={styles.footer}>
          <Text>Generado: {new Date().toLocaleString()}</Text>
          <Text>Pallet Control - Sistema de Gestión de Carga</Text>
        </View>
      </Page>
    </Document>
  );
};

export default ReporteDestinosPDF;

